module.exports = __webpack_public_path__ + "media/images/nahum-goldmann-medal-767fb8dc29b2010d9b67926c6dd5aeea.svg";